// GENERATED FILE - DO NOT MODIFY
export enum CatalogCostManagementMode {
    Variable = "V",
    Undefined = "U",
}

export let nameof = "CatalogCostManagementMode";
